// ============================================================
// Fee Types API
// ============================================================

import client from './axios';

export const feeTypesApi = {
  /**
   * Get list of fee types for a school
   */
  getFeeTypes: async (schoolId, skip = 0, limit = 100) => {
    const response = await client.get('/fee-types', {
      params: {
        school_id: schoolId,
        skip,
        limit,
      },
    });
    return response.data;
  },

  /**
   * Get single fee type by ID
   */
  getFeeTypeById: async (schoolId, id) => {
    const response = await client.get(`/fee-types/${id}`, {
      params: {
        school_id: schoolId,
      },
    });
    return response.data;
  },

  /**
   * Create a new fee type
   */
  createFeeType: async (schoolId, payload) => {
    const response = await client.post('/fee-types', payload, {
      params: {
        school_id: schoolId,
      },
    });
    return response.data;
  },

  /**
   * Update an existing fee type
   */
  updateFeeType: async (schoolId, id, payload) => {
    const response = await client.put(`/fee-types/${id}`, payload, {
      params: {
        school_id: schoolId,
      },
    });
    return response.data;
  },

  /**
   * Delete a fee type by ID
   */
  deleteFeeType: async (schoolId, id) => {
    const response = await client.delete(`/fee-types/${id}`, {
      params: {
        school_id: schoolId,
      },
    });
    return response.data;
  },
};
